let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a7pdV")).then(() => parcelRequire('bga69'));